import React from 'react';
import PropTypes from 'prop-types';

import IconWithText from 'components/Widgets/IconWithText';
import EmptyIconWithText from 'components/Widgets/EmptyIconWithText';

export default function Index({
  coach, link, bigIcon, iconClassName, contentClassName, wrapperClassName, children,
}) {
  const size = bigIcon ? '64px' : '40px';

  if (coach === null) {
    return (
      <EmptyIconWithText
        size={size}
        contentClassName={contentClassName}
        wrapperClassName={wrapperClassName}
      >
        <div className="mb-1 small fw-light text-gray-700">Coach</div>

        <div className="fw-semibold">
          -
        </div>
      </EmptyIconWithText>
    );
  }

  const content = children || (
    <>
      <div className="mb-1 small fw-light text-gray-700">Coach</div>

      <div className="fw-semibold text-gray-900">
        {coach.full_name}
      </div>
    </>
  );

  const icon = (
    <>
      {coach.avatar_url ? (
        <IconWithText
          iconClassName={`picture-icon ${bigIcon ? 'big-icon' : ''} rounded-circle ${iconClassName}`}
          iconStyle={{ backgroundImage: `url(${coach.avatar_url})` }}
          contentClassName={contentClassName}
          wrapperClassName={wrapperClassName}
        >
          {content}
        </IconWithText>
      ) : (
        <EmptyIconWithText
          size={size}
          contentClassName={contentClassName}
          wrapperClassName={wrapperClassName}
        >
          {content}
        </EmptyIconWithText>
      )}
    </>
  );

  return (
    <>
      {link ? (
        <a href={link} className="text-decoration-none">
          {icon}
        </a>
      ) : (
        <>
          {icon}
        </>
      )}
    </>
  );
}

Index.propTypes = {
  coach: PropTypes.object,
  link: PropTypes.string,
  bigIcon: PropTypes.bool,
  iconClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  children: PropTypes.node,
};

Index.defaultProps = {
  coach: null,
  link: null,
  bigIcon: true,
  iconClassName: '',
  contentClassName: '',
  wrapperClassName: '',
  children: null,
};
